import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

export const FileTypeZipIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    className={cn(className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4.49444 13.8576C9.613 14.7454 14.7317 14.7155 19.8502 13.8576V6.7415C19.8502 6.66042 19.824 6.58159 19.7753 6.51678L16.4046 2.0224C16.3338 1.92811 16.2228 1.87256 16.105 1.87256H5.61804C5.32006 1.87256 5.03422 1.99094 4.82352 2.20164C4.61282 2.41242 4.49444 2.69818 4.49444 2.99615V11.6104C4.49444 12.1667 4.36401 12.6381 4.36401 13.014C4.36401 13.5335 4.49444 13.8576 4.49444 13.8576Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M2.24719 12.8867V20.9737C2.24719 21.2716 2.36557 21.5575 2.57627 21.7682C2.78697 21.9789 3.07281 22.0973 3.37079 22.0973H20.5993C20.8973 22.0973 21.183 21.9789 21.3938 21.7682C21.6045 21.5575 21.7229 21.2716 21.7229 20.9737C21.7229 19.5385 21.7229 16.4164 21.7229 14.9812C21.7229 14.6832 21.6045 14.3974 21.3938 14.1867C21.183 13.976 20.8973 13.8576 20.5993 13.8576H3.74535C3.26751 13.8576 2.24719 12.8867 2.24719 12.8867Z"
      fill="#E57560"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M3.37079 13.8577C3.02886 13.8577 2.77924 13.719 2.59551 13.5482C2.42265 13.3875 2.24719 13.1042 2.24719 12.7341C2.24719 12.4965 2.36557 12.1502 2.57627 11.9396C2.78697 11.7289 3.07281 11.6105 3.37079 11.6105H4.49438V13.8577C4.49438 13.8577 4.59065 13.8577 3.37079 13.8577Z"
      fill="#A2584A"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.1049 1.87256V5.61791C16.1049 5.91588 16.2232 6.20173 16.4339 6.41242C16.6446 6.62312 16.9304 6.7415 17.2285 6.7415H19.8501C19.8501 6.66042 19.8239 6.58159 19.7752 6.51678L16.4045 2.0224C16.3337 1.92811 16.2227 1.87256 16.1049 1.87256Z"
      fill="#AFBDC7"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M11.6105 16.1048V19.8501C11.6105 20.0568 11.7783 20.2247 11.9849 20.2247C12.1917 20.2247 12.3595 20.0568 12.3595 19.8501V16.1048C12.3595 15.8981 12.1917 15.7303 11.9849 15.7303C11.7783 15.7303 11.6105 15.8981 11.6105 16.1048Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M13.8578 18.5861H15.4925C16.141 18.5861 16.6668 18.0604 16.6668 17.4118V16.9046C16.6668 16.256 16.141 15.7303 15.4925 15.7303C14.6621 15.7303 13.4832 15.7303 13.4832 15.7303C13.2764 15.7303 13.1086 15.8979 13.1086 16.1048V19.8501C13.1086 20.0568 13.2765 20.2247 13.4832 20.2247C13.6899 20.2247 13.8578 20.0568 13.8578 19.8501V18.5861ZM13.8578 17.837H15.4925C15.7272 17.837 15.9176 17.6467 15.9176 17.4118V16.9046C15.9176 16.6697 15.7272 16.4793 15.4925 16.4793H13.8578V17.837Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M7.86516 16.4793H9.92512L7.56557 19.6254C7.48044 19.7389 7.46669 19.8907 7.53015 20.0177C7.59361 20.1445 7.72332 20.2247 7.86516 20.2247H10.6742C10.8809 20.2247 11.0487 20.0568 11.0487 19.8501C11.0487 19.6435 10.8809 19.4756 10.6742 19.4756H8.6142L10.9737 16.3296C11.0589 16.216 11.0726 16.0642 11.0092 15.9373C10.9457 15.8105 10.816 15.7303 10.6742 15.7303H7.86516C7.65842 15.7303 7.4906 15.8981 7.4906 16.1048C7.4906 16.3115 7.65842 16.4793 7.86516 16.4793Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M10.487 9.97497V8.4885V8.48805C10.487 8.12419 10.6315 7.77515 10.8888 7.51789C11.146 7.26064 11.495 7.1161 11.8588 7.1161H12.1112C12.4751 7.1161 12.824 7.26064 13.0814 7.51789C13.3386 7.77515 13.4832 8.12419 13.4832 8.48805V9.97497C13.6141 9.91061 13.7347 9.82486 13.8398 9.71978C14.0911 9.46855 14.2322 9.12769 14.2322 8.77228C14.2322 8.76697 14.2322 8.76167 14.2322 8.75646C14.2322 8.44383 14.2706 8.13246 14.3464 7.82918L14.3465 7.829C14.5345 7.07673 14.1117 6.30657 13.3761 6.06136C13.3172 6.04167 13.2577 6.02189 13.1982 6.00203C12.4107 5.73956 11.5594 5.73956 10.7719 6.00203C10.7125 6.02189 10.653 6.04167 10.594 6.06136C9.85837 6.30657 9.43563 7.07673 9.62367 7.829V7.82918C9.69954 8.13246 9.73783 8.44383 9.73783 8.75646V8.77228C9.73783 9.12769 9.87905 9.46855 10.1304 9.71978C10.2354 9.82486 10.3561 9.91061 10.487 9.97497Z"
      fill="#E57560"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M10.4613 5.31597L10.535 5.29144C11.4762 4.97764 12.4938 4.97764 13.435 5.29144L13.5086 5.31597C13.5907 4.33305 13.8697 2.86042 14.7673 1.87256H9.20264C10.1002 2.86042 10.3792 4.33305 10.4613 5.31597Z"
      fill="#E57560"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M12.7341 8.48794V10.0752C12.7341 10.0999 12.7365 10.1244 12.7413 10.1487L12.8883 10.8838C12.9424 11.1543 12.8724 11.4347 12.6976 11.648C12.5227 11.8613 12.2614 11.9849 11.9857 11.9849C11.9852 11.9849 11.9848 11.9849 11.9843 11.9849C11.7085 11.9849 11.4472 11.8613 11.2724 11.648C11.0976 11.4347 11.0275 11.1543 11.0816 10.8838L11.2286 10.1489L11.2359 10.0752V8.48794C11.2359 8.32282 11.3015 8.16435 11.4184 8.04758C11.5351 7.93073 11.6936 7.86511 11.8587 7.86511H12.1111C12.2764 7.86511 12.4348 7.93073 12.5516 8.04758C12.6684 8.16435 12.7341 8.32282 12.7341 8.48794Z"
      fill="#E57560"
      fillRule="evenodd"
    />
  </svg>
);

export default FileTypeZipIcon;
